
/**
 * @nullable
 */
export type SolvePanelPlacementModelGapPositionPreferences = typeof SolvePanelPlacementModelGapPositionPreferences[keyof typeof SolvePanelPlacementModelGapPositionPreferences] | null;


export const SolvePanelPlacementModelGapPositionPreferences = {
  AfterFirst: 'AfterFirst',
  BeforeLast: 'BeforeLast',
  AtStart: 'AtStart',
  AtEnd: 'AtEnd',
  AfterSecond: 'AfterSecond',
} as const;
